import React from "react";

const ArbitratorView : React.FC = ()  => {
    return(
        <>
        
        
        </>
    )
}

export default ArbitratorView